import axios from 'axios'
import store from '@/store'

const validacoesForm = [
  {
    id: 1,
    nome: 'Validar CPF',
    funcao: 'validaCPF'
  },
  {
    id: 2,
    nome: 'Validar CNPJ',
    funcao: 'validaCnpj'
  }
]
const maskForm = [
  {
    id: 1,
    nome: 'CNPJ',
    mask: '##.###.###/####-##'
  },
  {
    id: 2,
    nome: 'CPF',
    mask: '###.###.###-##'
  },
  {
    id: 3,
    nome: 'CEP',
    mask: '#####-###'
  },
  {
    id: 4,
    nome: 'Telefone',
    mask: '(##) ####-####'
  },
  {
    id: 5,
    nome: 'Celular',
    mask: '(##) #####-####'
  },
  {
    id: 6,
    nome: 'Telefone / Celular',
    mask: ['(##) ####-####', '(##) # ####-####']
  },
  {
    id: 7,
    nome: 'Sem máscara',
    mask: 'text'
  }
]

export default {
  data() {
    return {
      baseUrlSecurity: this.$fccStore.state.baseUrlSeguranca,
      grupoListando: [],
      usuarioListando: [],
      lstFuncoesForm: [...validacoesForm],
      lstMaskForm: [...maskForm]
    }
  },
  methods: {
    stringLGPD(string, limite, limiteEstrela, primeiroNome) {
      let nome = ''
      let primeiro = ''
      let nomeFinal = ''
      if (primeiroNome) {
        const arr = string.split(' ')
        primeiro = arr[0]
        arr.forEach((element, index) => {
          nomeFinal = index > 0 ? nomeFinal + ' ' + element : ''
        })
      } else {
        nomeFinal = string
      }

      let x = 0

      for (let i = 0; i < nomeFinal.length; i++) {
        if (x < limite) {
          nome = nome + nomeFinal.charAt(i)
          x++
        } else {
          if (nomeFinal.charAt(i) == ' ') {
            nome = nome + ' '
            x = 0
          } else {
            nome = nome + '*'
            x++
          }
          if (x == limiteEstrela) {
            x = 0
          }
        }
      }
      return primeiro + nome
    },
    downloadArquivoGenerico(arq) {
      return new Promise((resolve, reject) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .get(`${store.state.baseUrlSga}File/Download?id=${arq}`, {
            headers: this.dadosLoginSession.fccTokenHeaders.headers,
            responseType: 'blob'
          })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    gerarCdBoletoPublicacao(idPublicacao) {
      const publicacao = {
        idPublicacao: idPublicacao
      }
      return new Promise((resolve, reject) => {
        axios
          .post(
            this.baseUrlPublicacao + 'ContaBancaria/GerarCdBoletoPublicacao',
            publicacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    validacaoDocumentos() {
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlPublicacao + 'ValidacaoDocumentos/Listar',
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    buscaConcursoInstituicao(spi) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlGestaoProjetos + 'Spi/ListarInstituicaoConcursoPorSpi/' + spi,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    alterarDataFechamentoConcursoInscricao(spi, data) {
      const originalDate = new Date(data)

      // Forçar para meia-noite do mesmo dia (horário local)
      originalDate.setHours(20, 59, 0, 0)
      const formatted = originalDate.toISOString().slice(0, 16)

      return new Promise((resolve, reject) => {
        axios
          .put(
            this.baseUrlPublicacao +
              'PublicacaoConcursoInscricao/AlterarDataFechamentoConcursoInscricao/' +
              spi +
              '/' +
              formatted,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    concursoInscricaoGetsPorSpi(inscricao) {
      return new Promise((resolve, reject) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .get(
            `${store.state.baseUrlPublicacao}PublicacaoConcursoInscricao/ConcursoInscricaoGetsPorSpi/` +
              inscricao.spi,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    alterarSPIControleWeb(cidade) {
      return new Promise((resolve, reject) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .put(
            `${store.state.baseUrlPublicacao}PublicacaoConcursoInscricao/AlterarConcursoInscricao`,
            cidade,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    inserirCidadeSPI(cidade) {
      return new Promise((resolve, reject) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .post(
            `${store.state.baseUrlPublicacao}PublicacaoCargoInscricao/AdicionarCidadeInscricao`,
            cidade,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    editCidadeSPI(cidade) {
      return new Promise((resolve, reject) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .put(
            `${store.state.baseUrlPublicacao}PublicacaoCargoInscricao/AlterarCidadeInscricao`,
            cidade,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deletePublicacao(idPublicacao) {
      return new Promise((resolve) => {
        axios
          .delete(
            `${store.state.baseUrlPublicacao}Publicacao/ExcluirPublicacao/${idPublicacao}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            resolve(true)
          })
          .catch((error) => {
            this.setErrorSystem(error)
            resolve(false)
          })
      })
    },
    async baixardownloadGoogleTempPublic(idArquivo) {
      return new Promise((resolve, reject) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .get(
            `${store.state.baseUrlSga}File/DownloadGoogleTempPublic?id=${idArquivo}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    bloqueadoStatusLiberacao() {
      this.callAlert('Bloqueado', '', 'error', 'error')
    },
    listandoDatasGenerico(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            store.state.baseUrlPublicacao + 'PublicacaoData/ListarPublicacaoDataPorId/' + id,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    usuariosListando: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSecurity + 'Cadastro/listartodoslogin',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.usuarioListando = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    gruposListando: function (permissao = true) {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(this.baseUrlSecurity + 'Perfil/listarperfil', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.grupoListando = permissao
            ? response.data
            : response.data.filter((element) => element.perexterno)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editandoParamTipoGenerico: function (hparametros) {
      this.carregaTexto(this.codeMensagem('C03'))
      return new Promise((resolve, reject) => {
        axios
          .put(
            store.state.baseUrlPublicacao + 'PublicacaoConfiguracao/AlterarConfiguracao',
            hparametros,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((res) => {
            resolve(res)
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    listandoAreaEspecificaGenerico: function () {
      return new Promise((resolve, reject) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .get(
            this.baseUrlGestaoProjetosConcurso + 'AreaEspecifica/Listar',
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    linstandoAreaDetalhadaGenerico: function () {
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlGestaoProjetosConcurso + 'AreaDetalhada/Listar',
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    linstandoInstituicaoGenerico() {
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlGestaoProjetosConcurso + 'Instituicao/Listar',
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    listarExportacaoInscricaoExportarGenerico(spi, tipo = 0) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlPublicacao +
              'InscricoesDeferidasCanceladas/ListarTratamentoInscricaoControle/' +
              spi,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            if (response.data.length > 0) {
              resolve(response.data.filter((e) => e.tp_liberacao == tipo))
            } else {
              resolve(response.data)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    listarControleSituacaoGenerico(spi) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            store.state.baseUrlPublicacao +
              'InscricoesDeferidasCanceladas/ListarControleSituacaoInscricaoEdital/' +
              spi,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    listarBancosGenerico() {
      return new Promise((resolve, reject) => {
        axios
          .get(store.state.baseUrlPublicacao + 'PublicacaoBanco/ListarBanco')
          .then((res) => {
            resolve(res.data)
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    listarTipoPagamentoGenerico() {
      return new Promise((resolve, reject) => {
        axios
          .get(
            store.state.baseUrlPublicacao + 'PublicacaoTipoPagamento/ListarPublicacaoTipoPagamento'
          )
          .then((res) => {
            resolve(res.data)
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    buscarEnderecoCep(cepJr) {
      this.carregaTexto(this.codeMensagem('C01'))

      return new Promise((resolve, reject) => {
        axios
          .get(store.state.baseUrlGestaoProjetos + 'Cep/ConsultaCEP?cep=' + cepJr)
          .then((res) => {
            if (res.data != null) {
              resolve(res.data)
            } else {
              reject(res)
            }
          })
          .catch(function (err) {
            reject(err)
          })
      }).finally(this.carregaTexto)
    }
  },
  computed: {
    baseUrlSir2() {
      return store.state.baseUrlSir2
    }
  }
}
